import React from 'react';
import withStore from "@/hocs/withStore";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import reachGoalYM from "@/Helpers/ReachGoalYM";
import reachGoalGA from "@/Helpers/ReachGoalGA";
import '@/Pages/B2B/scss/index.scss'
import BaseLayout from "@/Layouts/BaseLayout";
import LinkLoad from "@/Layouts/LinkLoad";


class B2B extends React.Component {
    componentDidMount = () => {
        reachGoalYM('b2b');
        reachGoalGA('b2b');
    };

    render() {
        return <BaseLayout {...this.props}>
            <section className={`section`}>
                <div className={`breadcrumbs`}>
                    <div className="container">
                        <Breadcrumbs
                            maxItems={2}
                            itemsAfterCollapse={2}
                        >
                            <LinkLoad className="breadcrumbs__link" href={`/`}>
                                Главная
                            </LinkLoad>
                            <p className="breadcrumbs__text">
                                Бизнес для бизнеса
                            </p>
                        </Breadcrumbs>
                    </div>
                </div>
                <div className={`container`}>
                    <h1 className={`h1 h1__account`}>Бизнес для бизнеса</h1>
                    <div className={`b2b`}>
                        <div className={`b2b-intro`}>
                            <div className={`b2b-intro__image`}>
                                <picture>
                                    <source type={`image/webp`}
                                            srcSet={`/storage/img/b2b/image_main.webp`}
                                    />
                                    <img src={`/storage/img/b2b/image_main.jpg`}
                                         alt={`Бизнес для бизнеса`}
                                         title={`Бизнес для бизнеса`}
                                         loading={`lazy`} />
                                </picture>
                            </div>
                            <div className={`b2b-intro__text`}>
                                <div className={`description`}>
                                    <p>
                                        Получите новые возможности для вашего бизнеса. Станьте партнёром
                                        и&nbsp;начните зарабатывать вместе с&nbsp;брендом PLATINA уже сейчас!
                                    </p>
                                    <p>
                                        Наши украшения знамениты на&nbsp;рынке ярким, запоминающимся
                                        и&nbsp;уникальным дизайном. Мы&nbsp;гарантируем наивысшее качество,
                                        соответствие свежим трендам ювелирной моды и&nbsp;самый широкий
                                        ассортимент.
                                    </p>
                                </div>
                                <a className={`btn btn__b2b mr8`}
                                   href="https://b2b.platina-kostroma.com/web-create-account"
                                   target={`_blank`}>
                                    Стать партнером
                                </a>
                                <a className={`btn btn__b2b`}
                                   href="https://b2b.platina-kostroma.com/web-login"
                                   target={`_blank`}>
                                    Личный кабинет партнера
                                </a>
                            </div>
                        </div>
                        <div className={`b2b-advantage`}>
                            <p>
                                Наши преимущества
                            </p>
                        </div>
                        <div className={`list-advantages`}>
                            <div className={`list-advantages__item`}>
                                <picture>
                                    <source type={`image/webp`}
                                            srcSet={`/storage/img/b2b/icon_1.webp`}
                                    />
                                    <img className={`image`}
                                         src={`/storage/img/b2b/icon_1.png`}
                                         alt={`Уникальный дизайн украшений`}
                                         title={`Уникальный дизайн украшений`}
                                         loading={`lazy`} />
                                </picture>
                                <p className={`text`}>Уникальный дизайн украшений</p>
                            </div>
                            <div className={`list-advantages__item`}>
                                <picture>
                                    <source type={`image/webp`}
                                            srcSet={`/storage/img/b2b/icon_2.webp`}
                                    />
                                    <img className={`image`}
                                         src={`/storage/img/b2b/icon_2.png`}
                                         alt={`Качество и экологичность продукции`}
                                         title={`Качество и экологичность продукции`}
                                         loading={`lazy`}
                                    />
                                </picture>
                                <p className={`text`}>Качество и экологичность продукции</p>
                            </div>
                            <div className={`list-advantages__item`}>
                                <picture>
                                    <source type={`image/webp`}
                                            srcSet={`/storage/img/b2b/icon_3.webp`}
                                    />
                                    <img className={`image`}
                                         src={`/storage/img/b2b/icon_3.png`}
                                         alt={`Современный подход к производству`}
                                         title={`Современный подход к производству`}
                                         loading={`lazy`}
                                    />
                                </picture>
                                <p className={`text`}>Современный подход к производству</p>
                            </div>
                            <div className={`list-advantages__item`}>
                                <picture>
                                    <source type={`image/webp`}
                                            srcSet={`/storage/img/b2b/icon_4.webp`}
                                    />
                                    <img className={`image`}
                                         src={`/storage/img/b2b/icon_4.png`}
                                         alt={`Индивидуальный подход к партнерам`}
                                         title={`Индивидуальный подход к партнерам`}
                                         loading={`lazy`}
                                    />
                                </picture>
                                <p className={`text`}>Индивидуальный подход к партнерам</p>
                            </div>
                            <div className={`list-advantages__item`}>
                                <picture>
                                    <source type={`image/webp`}
                                            srcSet={`/storage/img/b2b/icon_5.webp`}
                                    />
                                    <img className={`image`}
                                         src={`/storage/img/b2b/icon_5.png`}
                                         alt={`Квалифицированные специалисты`}
                                         title={`Квалифицированные специалисты`}
                                         loading={`lazy`} />
                                </picture>
                                <p className={`text`}>Квалифицированные специалисты</p>
                            </div>
                            <div className={`list-advantages__item`}>
                                <picture>
                                    <source type={`image/webp`}
                                            srcSet={`/storage/img/b2b/icon_6.webp`}
                                    />
                                    <img className={`image`}
                                         src={`/storage/img/b2b/icon_6.png`}
                                         alt={`Коллекции украшений на любой вкус`}
                                         title={`Коллекции украшений на любой вкус`}
                                         loading={`lazy`} />
                                </picture>
                                <p className={`text`}>Коллекции украшений на любой вкус</p>
                            </div>
                            <div className={`list-advantages__item`}>
                                <picture>
                                    <source type={`image/webp`}
                                            srcSet={`/storage/img/b2b/icon_7.webp`}
                                    />
                                    <img className={`image`}
                                         src={`/storage/img/b2b/icon_7.png`}
                                         alt={`Наличие и постоянное пополнение ассортимента`}
                                         title={`Наличие и постоянное пополнение ассортимента`}
                                         loading={`lazy`} />
                                </picture>
                                <p className={`text`}>Наличие и постоянное пополнение ассортимента</p>
                            </div>
                            <div className={`list-advantages__item`}>
                                <picture>
                                    <source type={`image/webp`}
                                            srcSet={`/storage/img/b2b/icon_8.webp`}
                                    />
                                    <img className={`image`}
                                         src={`/storage/img/b2b/icon_8.png`}
                                         alt={`Юридическая безопасность сотрудничества`}
                                         title={`Юридическая безопасность сотрудничества`}
                                         loading={`lazy`} />
                                </picture>
                                <p className={`text`}>Юридическая безопасность сотрудничества</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </BaseLayout>
    }
}

export default withStore(B2B)
